exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner[data-v-e3f34494] {\n  padding: 1em 1em;\n}\n.b-tabs[data-v-e3f34494] {\n  background: #fff;\n}\n", ""]);

// exports
